import React from 'react'
import { myHospitals } from '../../resources'
import { Tabs } from 'antd'
import PacientesNext from '../pacientes-next'


const onChange = (key) => { console.log(key) }

export default function Dash() {

    // Create items for TABS
    myHospitals.forEach(h => {
        h.label = h.nombre;
        h.key = h._id;
        h.children = <PacientesNext id_hospital={h._id} />
    });

    return (
        <div className='mainContainer'>

            <h4>Pacientes de los diferentes hospitales</h4>
            
            <Tabs defaultActiveKey="1" items={myHospitals} onChange={onChange} />

        </div>
    )
}
